import { Message } from "element-ui";
// import store from "../../store/index";
// import router from '../../router/index';
import Token from "../../utils/token";
// import ErrorMessager from "../error/ErrorMessager";
import config from "../app";

const TokenName = "access_token";
export function inject(service, option) {
  // request拦截器
  service.interceptors.request.use(
    (conf) => {
      // 识别请求中的LoadingTag,改变Store中该Tag的loading状态为true
      // config.headers.loadingTag &&
      //   store.commit("loading/startLoading", config.headers.loadingTag);
      if (Token.get() && (!option || !option.withoutToken)) {
        conf.headers.Authorization = `bearer ${Token.get()}`;
        conf.data = conf.data || {};
      }
      return conf;
    },
    (error) => {
      console.log("Request拦截器Error ==>", error);
      Promise.reject(error);
    },
  );
  // response拦截器
  service.interceptors.response.use(
    (response) => {
      if (response.status === 200) {
        // return response.data;
        // 当返回的相应中有code才做进一步判断
        if (
          response.data || `${response.data.code}` === "200"
        ) {
          // console.log('444', response.data);
          return response.data;
        }
          console.log("报错retro19211700==>", response);
          // return Promise.reject(new Error(response.data));
      }

      // return Promise.reject(new Error("请求响应码错误!"));
    },
    (error) => {
      console.log('555', JSON.stringify(error));
      console.log('666', error.response);
      // Message.error("请求异常!");
      return Promise.resolve(error.response);
    },
  );
  service.interceptors.request.onerror = function (res) {
    console.log('777', res);
  };
}

const errorHandler = (response) => {
  console.log("错误的响应信息 ==>", response);
  if (!response || !response.status) {
    Message.error("服务器无响应,请检查您的网络状态!");
    return Promise.reject(new Error("服务器无响应,请检查您的网络状态!"));
  }
  console.log("响应异常 ==>", response);
  switch (response.status) {
    case 401:
      Message.error(new Error("Token失效,请重新登录"));
      // store.dispatch("user/handleLogout").then(() => {
      //   location.reload(true);
      // });
      break;
    case 403:
      Message.error(new Error("您没有访问权限!"));
      break;
    case 404:
      Message.error(new Error("404:访问的资源不存在!"));
      break;
    case "401":
      Message.error(new Error("Token失效,请重新登录"));
      break;
    case "403":
      Message.error(new Error("您没有访问权限!"));
      break;
    case "404":
      Message.error(new Error("404:访问的资源不存在!"));
      break;
    default:
      break;
  }
};

export default inject;
